import * as PIXI from "pixi.js";
import Main from "../Main";
import TopLayer from "../layers/TopLayer";
import { EventBus, EnumEventBus } from "../managers/EventBus";
import TextureManager from "../managers/TextureManager";
import { fireworkObject, INITIAL_FRAME_COLOR, INITIAL_FRAME_TYPE } from "../types/Config";
import FrameAnimation from "../animations/FrameAnimation";
import { FireworksColor, FireworksType } from "../types/Enum";


export default class BoxFrame extends PIXI.Container {
  private Main = Main.getInstance();
  private TopLayer = TopLayer.getInstance();
  private EventBus = EventBus;
  private frame: PIXI.Sprite;
  private typeFrame: PIXI.Sprite;
  private dim: { width: number, height: number }
  private currColor = INITIAL_FRAME_COLOR;
  private currType = INITIAL_FRAME_TYPE;
  constructor() {
    super()
    this.addBounds();
    this.addFrame();
    this.addTypeFrame();
    this.addToLayer();
    this.EventBus.on(EnumEventBus.updateWFireworkTexture, (index: number) => this.updateTexture(index))
  }
  getTexture = (name: FireworksColor | FireworksType) => name == FireworksType.full
    ? new PIXI.Texture(PIXI.Texture.EMPTY)
    : TextureManager.getTexture(`./images/scene/b2_${name}.png`);

  addBounds() {
    this.dim = this.Main.getDim();
    this.x = this.dim.width / 2;
    this.y = this.dim.height / 2;
  }
  addFrame() {
    const texture = this.getTexture(FireworksColor.purple);
    this.frame = new PIXI.Sprite(texture);
    this.frame.width = 605;
    this.frame.height = 570;
    this.frame.anchor.set(.5);
    this.addChild(this.frame);
  }
  addTypeFrame() {
    const texture = this.getTexture(FireworksType.full);
    this.typeFrame = new PIXI.Sprite(texture);
    this.typeFrame.width = 605;
    this.typeFrame.height = 570;
    this.typeFrame.anchor.set(.5);
    this.addChild(this.typeFrame);
  }
  updateTexture(index: number) {
    const firework = fireworkObject[index];
    if (firework.color == this.currColor && firework.type == this.currType) {
      return
    }
    new FrameAnimation(this, .3, 200, () => {
      this.frame.texture = this.getTexture(firework.color);
      this.typeFrame.texture = this.getTexture(firework.type);
      new FrameAnimation(this, 1, 200, () => {
        this.currColor = firework.color;
        this.currType = firework.type;
      });
    })
  }
  addToLayer() {
    this.TopLayer.addChild(this);
  }
}